export default __webpack_public_path__ + "static/media/warehousing-not-selected_skyblue.3dfcf0d7.svg";